import React, { useEffect, useState } from "react";
import {
  StateSwitcherSelectors,
  UserContextSelectors
} from "../../redux/selectors";
import { useSelector } from "react-redux";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { AppFeatures } from "../../constants/featureFlags";
import { performAction } from "../../utils/actionUtils";
import { useAccountCommunicationHandlers } from "../../hooks";
import { useFeature } from "../../hooks/useFeature";
import { PageContextUtils } from "../../utils";
import { TrackingInfo } from "../../components/tracking/TrackingInfoHeader";

const getProps = async (brandId, props) => {
  const { name } = PageContextUtils.getClientProviderData();

  try {
    const { getLogoTypesProps } = await import(
      /* webpackChunkName: "[request]" */
      `../Brands/${brandId}/${name}/LogoTypes.resource`
    );

    return getLogoTypesProps(props);
  } catch {
    return null;
  }
};

const LogoTypes = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const selectedState = useSelector(StateSwitcherSelectors.selectedState);
  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );
  const [logoTypesProps, setProps] = useState(null);
  const { openMyAccount } = useAccountCommunicationHandlers();

  useEffect(() => {
    const getPropsAsync = async () => {
      setProps(
        await getProps(brandId, {
          isAuthenticated,
          selectedState,
          isControlCenterActive,
          performAction,
          openMyAccount
        })
      );
    };

    getPropsAsync();
  }, [
    brandId,
    isAuthenticated,
    selectedState,
    isControlCenterActive,
    openMyAccount
  ]);

  if (!logoTypesProps?.length) return null;
  const isLinkDisabled = logoTypesProps.href === null;

  return (
    <div className="aClogoTypes">
      {logoTypesProps.map(innerProps => {
        if (!innerProps) return null;

        const { linkProps, imgSrc, svgId, name } = innerProps;
        const trackingInfoLocal = TrackingInfo
          ? Object.assign({}, TrackingInfo, { dataLabel: name })
          : Object.assign({}, TrackingInfo, {
              dataCategory: "default",
              dataAction: "click",
              dataLabel: name
            });

        return (
          <a
            key={linkProps.className}
            {...linkProps}
            data-category={trackingInfoLocal.dataCategory}
            data-action={trackingInfoLocal.dataAction}
            data-label={trackingInfoLocal.dataLabel}
            data-value=""
            style={{
              cursor: isLinkDisabled ? "default" : "pointer"
            }}
          >
            {imgSrc && <img src={imgSrc} alt="logo-type" />}
            {svgId && <SVGIcon2 iconName={svgId} asImage />}
          </a>
        );
      })}
    </div>
  );
};

export default LogoTypes;
